export default __webpack_public_path__ + "b9b117e277b604aa4ce2b0b0d191e4bb.png";